import { loadRegistry } from './modules.ts';

/** Registro único de módulos activos (archivo matriz de la interfaz). */
export const registry = loadRegistry();
